<div class="wrapper">
  <mat-card class="content">
    <mat-card-content>
      <h2 class="card-title">Je mag me plannen voor de volgende voertuigen</h2>
      <div class="list-items">
        <div class="list-item-wrapper headers">
          <div class="list-item-col-wrapper">
            <div class="list-item-col">Naam</div>
            <div class="list-item-col">Zitplaatsen</div>
            <div class="list-item-col hide-column">Omschrijving</div>
            <div class="list-item-col"></div>
          </div>
        </div>
        <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper">
          @for (vehicle of vehicles(); track vehicle.id) {
            <div class="list-item-wrapper">
              <div class="list-item-col-wrapper">
                <div class="list-item-col">
                  {{ vehicle.name ?? '' }}
                </div>
                <div class="list-item-col">
                  {{ vehicle.seats ?? '-' }}
                </div>
                <div class="list-item-col hide-column">
                  {{ vehicle.description ?? '-' }}
                </div>
                <div class="list-item-col">
                  <div class="list-item-buttons">
                    <mat-slide-toggle
                      (change)="toggleChange($event, vehicle.id!)"
                      [disabled]="!userCanModify"
                      [checked]="vehicle.checked"
                    >
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>
          }
        </cdk-virtual-scroll-viewport>
      </div>
    </mat-card-content>
  </mat-card>
</div>
